import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface ActiveMerchandise {
  id: number;
  merchandise: string;
  isActive: string;
}

export const activeMerchandiseApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllActiveMerchandises: builder.query<ActiveMerchandise[], void>({
      query: () => ({
        url: "merchandise/active-merchandise",
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<ActiveMerchandise[]>) => res.results ?? [],
      providesTags: [{ type: "Merchandise", id: "ACTIVE_LIST" }],
    }),
  }),
});

export const { useGetAllActiveMerchandisesQuery } = activeMerchandiseApiSlice;
